import styled from 'styled-components';

import { Skeleton } from '@treezor/design-system';

const TemplateSkeletonWrapper = styled.div<{ $theme: 'dark' | 'light'; $borderRadius?: string }>`
  padding: 2.5rem;
  background-color: ${(props) => (props.$theme === 'dark' ? props.theme.palette.darkBlue : props.theme.palette.white)};
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  & .MuiSkeleton-root {
    ${(props) => props.$theme === 'dark' && `background-color: ${props.theme.palette.secondary}`};
  }
  border-radius: ${({ $borderRadius }) => $borderRadius};
  height: calc(100vh - 350px);
  min-height: 480px;
`;

const SkeletonSection = styled.div`
  flex-direction: column;
  display: flex;
  gap: 0.7rem;
`;

interface ITemplateSkeleton {
  theme: 'dark' | 'light';
  borderRadius?: string;
}

export const TemplateSkeleton = ({ theme, borderRadius }: ITemplateSkeleton) => (
  <TemplateSkeletonWrapper $theme={theme} $borderRadius={borderRadius}>
    <Skeleton width="15%" height="0.8rem" borderRadius="300" />
    <SkeletonSection>
      <Skeleton width="45%" height="1.2rem" borderRadius="300" />
      <Skeleton width="65%" height="1.3rem" borderRadius="300" />
    </SkeletonSection>
  </TemplateSkeletonWrapper>
);
